import { FC, RefAttributes } from "react";
import { Box } from "@mui/material";
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from "@mui/x-data-grid-pro";

type CustomGridActionsCellItemProps = {
  bgColor: string;
  bgColorHover: string;
  dataTestId?: string;
} & GridActionsCellItemProps &
  RefAttributes<HTMLButtonElement>;

const CustomGridActionsCellItem: FC<CustomGridActionsCellItemProps> = ({
  bgColor,
  bgColorHover,
  dataTestId,
  ...props
}) => (
  <GridActionsCellItem
    {...props}
    data-testid={dataTestId}
    material={{
      sx: {
        ".MuiListItemIcon-root": {
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundColor: bgColor,
          width: "36px",
          height: "36px",
          padding: "0.5rem",
          marginRight: "0.5rem",
          borderRadius: "5px",
          "&:hover": {
            backgroundColor: bgColorHover,
          },
        },
      },
    }}
  />
);

export default CustomGridActionsCellItem;
